import { decodeUri } from './decode'
import applyHttpsImage from 'lib/apply-https-img'
/**
 * 是否支持webp格式
 * @type {boolean}
 */
const canUseWebp = (() => {
  if (typeof document === 'undefined') {
    return false
  }
  const elem = document.createElement('canvas')
  if (elem && elem.getContext && elem.getContext('2d')) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0
  }
  return false
})()

function getDomain() {
  const domainList = [
    'sf1-ttcdn-tos.pstatp.com',
    'sf3-ttcdn-tos.pstatp.com',
    'sf6-ttcdn-tos.pstatp.com',
  ]
  return domainList[Math.floor(Math.random() * domainList.length)]
}

function getSize(width = 0, height = 0, autoPixelRatio = false) {
  if (!width && !height) {
    return 'noop'
  }

  // 服务器端默认2倍大小，客户端根据实际的window?.devicePixelRatio
  if (autoPixelRatio) {
    let pixelRatio = 2
    if (typeof window !== 'undefined' && window?.devicePixelRatio) {
      pixelRatio = window?.devicePixelRatio
    }
    return `${Math.abs(width * pixelRatio)}x${Math.abs(height * pixelRatio)}`
  }
  return `${Math.abs(width)}x${Math.abs(height)}`
}

function getExt(src: string): string {
  if (canUseWebp) {
    return 'webp'
  }
  const matches = src.match(/(?:\.)(\w+)(?:\?.*)?$/)
  if (!matches || !matches[1]) {
    return 'image'
  }

  if (!canUseWebp && matches[1] === 'webp') {
    return 'image'
  }

  return matches[1]
}

type GenImgAttrsData = {
  src: string
  unoptimized: boolean
  width?: number
  height?: number
  autoPixelRatio?: boolean
}

export function getOptimizedImage(params: GenImgAttrsData): string {
  const { src, unoptimized, width, height, autoPixelRatio } = params
  if (unoptimized) {
    return applyHttpsImage(src)
  }
  // 获取uri，如果不是tos地址，就不匹配
  const uri = decodeUri(src)
  if (!uri) {
    return applyHttpsImage(src)
  }

  const domain = getDomain()
  const size = getSize(width, height, autoPixelRatio)
  const ext = getExt(src)
  return `//${domain}/img/${uri}~${size}.${ext}`
}
